import React from 'react'
import '../styles/layout/Contact.css'
import { Container, Image } from 'react-bootstrap';
import banner from '../assests/contact-banner.png'

const ContactBanner = () => {
  return (
    <section className="page-hero contactBanner">
      <Container>
        <div className="page-hero__band">
          <Image src={banner} alt="" />
          <span className="page-hero__band-tint" aria-hidden="true" />
          <span className="page-hero__band-wash" aria-hidden="true" />
          <span className="page-hero__band-edge" aria-hidden="true" />

          <div className="page-hero__copy">
            <h1>Contact Us</h1>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default ContactBanner
